import { FiscalPrinter } from '@shared/app/scripts/services/fiscal-printer';
import { Printer } from '@shared/app/scripts/services/printer';
import { Sales } from '@shared/app/scripts/services/sales';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Service printReceipt - prints the current transaction.
 */
angular
  .module('posApp')
  .factory(
    'printReceipt',
    (
      $q: ng.IQService,
      fiscalPrinter: FiscalPrinter,
      isFiscalReturn,
      isFiscalSale,
      legacyPrint,
      pos,
      printCoupon,
      printer: Printer,
      sales: Sales,
      settingsManager: SettingsManager,
    ) => {
      // TODO move this logic to the fiscalPrinter service in v7/shared
      const printReceipt = (transaction = null, returnTransaction = null) => {
        if (!transaction) {
          transaction = pos.transaction;
        }

        printCoupon(transaction);

        if (settingsManager.settings.fiscalPrinter?.active) {
          let fiscalPrint;

          if (returnTransaction) {
            fiscalPrint = fiscalPrinter.return(transaction, returnTransaction);
          } else {
            fiscalPrint = fiscalPrinter.receipt(transaction);
          }

          return fiscalPrint.then(
            ({ fiscalReceiptNumber, fiscalShiftNumber, fiscalDate }) => {
              sales.addFiscalReceipt(
                transaction._id,
                fiscalReceiptNumber,
                fiscalShiftNumber,
                fiscalDate,
                settingsManager.settings.fiscalPrinter?.printerId,
              );
            },
            (errorMessage) => {
              // printing failed
              fiscalPrinter.reset();

              return $q.reject(errorMessage);
            },
          );
        } else {
          if (settingsManager.settings.noAutoPrint) {
            return printer.useDefault('', false, !!transaction.payments.cash);
          } else {
            return legacyPrint.receipt(transaction, false);
          }
        }
      };

      return printReceipt;
    },
  );
